import styled, { css } from 'styled-components'
import Skeleton from '@app.components/Skeleton'

const ActivityTableRowLoading = () => {
  return (
    <StyledLoadingWrapper data-testid="activity-table-row-loading">
      <td>
        <div className="item-recruit-company">
          <Skeleton width={60} height={60} className="image-skeleton" />
          <Skeleton width={100} height={10} />
        </div>
      </td>
      <td>
        <div className="item-recruit-name">
          <div className="recruit-link">
            <div className="recruit-name-container">
              <Skeleton width={72} height={16} />
            </div>
            <Skeleton
              width={200}
              height={10}
              className="recruit-category-skeleton"
            />
          </div>
        </div>
      </td>
      <td>
        <div className="item-recruit-type">
          <Skeleton width="5em" height={10} />
        </div>
      </td>
      <td>
        <div className="item-location">
          <Skeleton width="5em" height={10} />
        </div>
      </td>
      <td>
        <div className="item-recruit-close">
          <Skeleton width={72} height={10} />
        </div>
      </td>
      <td>
        <div className="item-view-count">
          <Skeleton width={50} height={10} />
        </div>
      </td>
      <td>
        <div className="item-button-scrap">
          <Skeleton width={32} height={21} />
        </div>
      </td>
    </StyledLoadingWrapper>
  )
}

export default ActivityTableRowLoading

const StyledLoadingWrapper = styled.tr`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.background.bg_8};

    .item-recruit-company {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 20px;

      .image-skeleton {
        margin-right: 20px;
      }
    }

    .item-recruit-name,
    .item-recruit-type,
    .item-location,
    .item-recruit-close,
    .item-view-count,
    .item-button-scrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
    }

    .item-recruit-name {
      justify-content: flex-start;
      padding-right: 20px;
    }

    .recruit-link {
      width: 100%;
    }

    .recruit-category-skeleton {
      margin-top: 5px;
    }
  `}
`
